import { DSCardWrapper } from "@components/design-system/molecules";
import {
  faChevronCircleDown,
  faChevronCircleUp,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useState } from "react";

const taskStatusToVariant = {
  SUCCEEDED: "success",
  ACCEPTED: "success",
  FAILED: "danger",
  REJECTED: "danger",
  PENDING: "warning",
  STARTED: "info",
};

export function CompanionSessionTask({
  task,
  defaultExpanded = false,
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const variant = taskStatusToVariant[task.status] || "default";

  return (
    <div
      className="flex flex-col px-1 w-full"
      data-testid={`companion-task-${task.companionSessionTaskUuid}`}
    >
      <DSCardWrapper
        variant={variant}
        padding="p-sm"
        dataTestId={`task-card-${task.companionSessionTaskUuid}`}
      >
        <div
          className={`flex items-center gap-2 text-md justify-between cursor-pointer text-${variant}`}
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <FontAwesomeIcon
            icon={
              isExpanded ? faChevronCircleUp : faChevronCircleDown
            }
          />
          <span
            className="flex-1 font-bold"
            data-testid={`task-name-${task.name}`}
          >
            {task.name}
          </span>
        </div>
        {isExpanded && (
          <div className={`text-${variant} text-sm mt-1`}>
            {task.taskStepDescription}
          </div>
        )}
        <div className="text-xs text-secondary justify-self-end mt-xs">
          {moment(task.createdAt).format("MMM Do h:mm A")}
        </div>
      </DSCardWrapper>
    </div>
  );
}

export function CompanionTasksSection({ tasks }) {
  if (!tasks?.length) {
    return null;
  }
  const sortedTasks = [...tasks].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
  );

  return sortedTasks.map((task) => (
    <CompanionSessionTask
      task={task}
      key={task.companionSessionTaskUuid}
    />
  ));
}
